import {
  guessBrowser, isWebRTCSupported, rebrandedChromeBrowser, isNonChromiumEdge, TWILIO_SUPPORTED_CHROME_BASED_BROWSERS,
} from 'utils/browserUtils';

const isVideoRTCSupported = () => {
  const browser = guessBrowser();
  const rebrandedChrome = rebrandedChromeBrowser(browser);
  return !!browser
    && isWebRTCSupported()
    && (!rebrandedChrome || TWILIO_SUPPORTED_CHROME_BASED_BROWSERS.includes(rebrandedChrome))
    && !isNonChromiumEdge(browser);
};

export default isVideoRTCSupported;
